import 'swiper/dist/css/swiper.css';

import Swiper from "swiper";
import {ProductListItem} from "./ProductListItem";

export class DefaultProductsCarousel {
    constructor(containerSelector = '.default-products-slider > .swiper-container') {
        this.containerSelector = containerSelector;

        new Swiper(this.containerSelector, {
            slidesPerView: 'auto',
            spaceBetween: 65,
            breakpoints: {
                768: {
                    spaceBetween: 21
                },
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
        });

        this.initProductItems();
    }

    initProductItems() {
        const items = document.querySelectorAll(this.containerSelector + ' .swiper-slide');

        for (let item of items)  {
            new ProductListItem(item);
        }
    }
}